"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocalTracks = exports.createLocalAudioTrack = exports.createLocalVideoTrack = exports.connect = exports.version = void 0;
const loglevel_1 = __importDefault(require("loglevel"));
const SignalClient_1 = require("./api/SignalClient");
const options_1 = require("./options");
const errors_1 = require("./room/errors");
const Room_1 = __importDefault(require("./room/Room"));
const LocalAudioTrack_1 = __importDefault(require("./room/track/LocalAudioTrack"));
const LocalVideoTrack_1 = __importDefault(require("./room/track/LocalVideoTrack"));
const Track_1 = require("./room/track/Track");
var version_1 = require("./version");
Object.defineProperty(exports, "version", { enumerable: true, get: function () { return version_1.version; } });
/**
 * Connects to a LiveKit room
 *
 * ```typescript
 * connect('wss://myhost.livekit.io', token, {
 *   // publish audio and video tracks on joining
 *   audio: true,
 *   video: {
 *     resolution: VideoPresets.hd,
 *     facingMode: {
 *       ideal: "user",
 *     }
 *   }
 * })
 * ```
 * @param url URL to LiveKit server
 * @param token AccessToken, a JWT token that includes authentication and room details
 * @param options
 */
function connect(url, token, options) {
    return __awaiter(this, void 0, void 0, function* () {
        // set defaults
        options || (options = {});
        options.logLevel || (options.logLevel = options_1.LogLevel.info);
        if (options.audio === undefined)
            options.audio = false;
        if (options.video === undefined)
            options.video = false;
        loglevel_1.default.setLevel(options.logLevel);
        const config = {};
        if (options.iceServers) {
            config.iceServers = options.iceServers;
        }
        const client = new SignalClient_1.WSSignalClient();
        const room = new Room_1.default(client, config);
        // connect to room
        yield room.connect(url, token, {
            autoSubscribe: options === null || options === void 0 ? void 0 : options.autoSubscribe,
        });
        // add tracks if available
        let { tracks } = options;
        if (!tracks) {
            if (options.audio || options.video) {
                tracks = yield createLocalTracks({
                    audio: options.audio,
                    video: options.video,
                });
            }
        }
        if (tracks) {
            for (let i = 0; i < tracks.length; i += 1) {
                const track = tracks[i];
                // translate publish options
                const trackOptions = {};
                if (track.kind === Track_1.Track.Kind.Video.toString()
                    || track.kind === Track_1.Track.Kind.Video) {
                    trackOptions.videoCodec = options === null || options === void 0 ? void 0 : options.videoCodec;
                    trackOptions.videoEncoding = options === null || options === void 0 ? void 0 : options.videoEncoding;
                    trackOptions.simulcast = options === null || options === void 0 ? void 0 : options.simulcast;
                }
                else if (track.kind === Track_1.Track.Kind.Audio.toString()
                    || track.kind === Track_1.Track.Kind.Audio) {
                    trackOptions.audioBitrate = options.audioBitrate;
                }
                yield room.localParticipant.publishTrack(track, trackOptions);
            }
        }
        return room;
    });
}
exports.connect = connect;
/**
 * Creates a [[LocalVideoTrack]] with getUserMedia()
 * @param options
 */
function createLocalVideoTrack(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const tracks = yield createLocalTracks({
            audio: false,
            video: options,
        });
        return tracks[0];
    });
}
exports.createLocalVideoTrack = createLocalVideoTrack;
function createLocalAudioTrack(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const tracks = yield createLocalTracks({
            audio: options,
            video: false,
        });
        return tracks[0];
    });
}
exports.createLocalAudioTrack = createLocalAudioTrack;
/**
 * creates a local video and audio track at the same time
 * @param options
 */
function createLocalTracks(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const constraints = {};
        if (!options)
            options = {};
        if (options.audio === undefined)
            options.audio = {};
        // default video options
        const videoOptions = Object.assign({}, options_1.VideoPresets.qhd.resolution);
        if (typeof options.video === 'object' && options.video) {
            Object.assign(videoOptions, options.video);
            if (options.video.resolution) {
                Object.assign(videoOptions, options.video.resolution);
            }
        }
        if (options.video === false) {
            constraints.video = false;
        }
        else {
            // use defaults
            constraints.video = videoOptions;
        }
        constraints.audio = options.audio;
        const stream = yield navigator.mediaDevices.getUserMedia(constraints);
        const tracks = [];
        stream.getTracks().forEach((mediaStreamTrack) => {
            let trackOptions = mediaStreamTrack.kind === 'audio' ? options.audio : options.video;
            if (typeof trackOptions === 'boolean' || !trackOptions) {
                trackOptions = {};
            }
            tracks.push(createLocalTrack(mediaStreamTrack, trackOptions));
        });
        return tracks;
    });
}
exports.createLocalTracks = createLocalTracks;
/** @internal */
function createLocalTrack(mediaStreamTrack, options) {
    let name;
    if (options instanceof Object && options.name) {
        name = options.name;
    }
    switch (mediaStreamTrack.kind) {
        case 'audio':
            return new LocalAudioTrack_1.default(mediaStreamTrack, name, options);
        case 'video':
            return new LocalVideoTrack_1.default(mediaStreamTrack, name, options);
        default:
            throw new errors_1.TrackInvalidError(`unsupported track type: ${mediaStreamTrack.kind}`);
    }
}
//# sourceMappingURL=livekit.js.map